import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { DashboardLayout } from "../shared/ui/layouts";
import { Home, Dashboard, DemoUser, DemoAdmin, FlightChangeDetails, FlightChangeDetailsSkeleton, FlightChangesCases, Help, UnsubscribeLandingPage, UnsubscribeThankYouPage, FeedbackThankYouPage } from "../pages";
import { Login } from "../pages/auth";
import { ConfigurationExample } from "../pages/config";
import { ThemeDemo } from "../components/ui";
import { RoleProtectedRoute, ProtectedRoute } from "../components/auth";
import { useAuth } from "../hooks/auth";
import { useMenuItems } from "../shared/hooks/useMenuItems";
import { systemItems } from "../config/layout";
import { ROUTES } from "./routes";

export const AppRouter: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { menuItems } = useMenuItems();

  return (
    <Routes>
      <Route path="/" element={<DashboardLayout menuItems={menuItems} systemItems={systemItems} />}>
        <Route index element={isAuthenticated ? <Navigate to={ROUTES.DASHBOARD} replace /> : <Home />} />
        <Route path="login" element={<Login />} />
        <Route path={ROUTES.UNSUBSCRIBE.slice(1)} element={<UnsubscribeLandingPage />} />
        <Route path={ROUTES.UNSUBSCRIBE_THANK_YOU.slice(1)} element={<UnsubscribeThankYouPage />} />
        <Route path={ROUTES.FEEDBACK_THANK_YOU.slice(1)} element={<FeedbackThankYouPage />} />
        <Route path="theme" element={<ProtectedRoute><ThemeDemo /></ProtectedRoute>} />
        <Route path="config" element={<ProtectedRoute><ConfigurationExample /></ProtectedRoute>} />
        <Route path="help" element={<ProtectedRoute><Help /></ProtectedRoute>} />
        <Route path="dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route
          path="flight-change-cases"
          element={
            <RoleProtectedRoute requiredRoles={["admin", "supervisor", "agente"]}>
              <FlightChangesCases />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="flight-change-cases/:id"
          element={
            <RoleProtectedRoute
              requiredRoles={["admin", "supervisor", "agente"]}
              loadingFallback={<FlightChangeDetailsSkeleton />}
            >
              <FlightChangeDetails />
            </RoleProtectedRoute>
          }
        />
        <Route 
          path="demo-user" 
          element={
            <RoleProtectedRoute requiredRoles={["demo.user"]}>
              <DemoUser />
            </RoleProtectedRoute>
          } 
        />
        <Route 
          path="demo-admin" 
          element={
            <RoleProtectedRoute requiredRoles={["demo.admin"]}>
              <DemoAdmin />
            </RoleProtectedRoute>
          } 
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};
